module.exports = __webpack_public_path__ + "img/afval-fase-2.d51964a2.png";